import React, {useContext, useEffect} from "react";
import {AuthContext} from "../context/AuthContext";
import { useNavigate } from 'react-router-dom';

const LogoutPage = () => {
  const navigate = useNavigate();
  const { setUsuario } = useContext(AuthContext);

  useEffect(()=>{
    setUsuario(null)
    localStorage.clear();
    navigate('/login');
  },[])

  return (
    <div>Saliendo...</div>
  )
}

export default LogoutPage
